
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux'
import { useFourThreeThreeBApi } from '../../resources/hooks/api/fourThreeThreeBApiHook';
import Select from 'react-select';
import toast from 'react-hot-toast';
import "react-datepicker/dist/react-datepicker.css";
import { MONTHS, STATES } from '../../resources/constants';
import { calculateMaxHeightContent, lastYears } from '../../resources/functions';
import Form from 'react-bootstrap/Form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { CreateFourThreeThreeFormI, PersonalBalanceFormI, PersonalIncomeFormI } from '../../resources/form-props';
import { PersonalBalanceValidate, PersonalIncomeValidate } from '../../resources/form-validator'
import Spinner from 'react-bootstrap/Spinner';
import filterSolidIcon from '../../assets/images/filter-solid-icon.svg';
import DatePicker from "react-datepicker";
import moment from 'moment'
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import html2pdf from 'html2pdf.js';
import "./style.css";

import { getBranch } from '../../store/user/selectors'

interface Props {

}

const PersonalIncomeStatement: React.FC<Props> = () => {
    const { t } = useTranslation('scenes.PersonalIncomeStatement');
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const initData = {
        section_one_primary_income: [],
        section_one_other_income: [],
        section_two_fixed_expense: [],
        section_two_variable_expense: [],
        section_three_investments: [],
        section_four_budgets: [],
    };
    const branchData = useSelector(getBranch)
    const pagesRefs = useRef<(HTMLDivElement | null)[]>([]);

    const { getPersonalIncomeStatment, createPersonalIncomeStatment } = useFourThreeThreeBApi();
    const [currentMonthIndex, setCurrentMonthIndex] = useState<any>(new Date().getMonth());
    const currentMonthName = months[currentMonthIndex];
    const [showLoader, setShowLoader] = useState<boolean>(false)
    const [searchParams, setSearchParams] = useState<any>({
        month: { value: new Date().getMonth() + 1, label: currentMonthName },
        year: { value: new Date().getFullYear(), label: '' + new Date().getFullYear() }
    });
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);

    const [totalSectionOneMonthlyIncome, setTotalSectionOneMonthlyIncome] = useState<number>(0);
    const [totalSectionOneAnnualIncome, setTotalSectionOneAnnualIncome] = useState<number>(0);

    const [totalSectionTwoFixedMonthlyIncome, setSectionTwoFixedMonthlyIncome] = useState<number>(0);
    const [totalSectionTwoFixedAnnualIncome, setSectionTwoFixedAnnualIncome] = useState<number>(0);

    const [totalSectionTwoVariableMonthlyIncome, setSectionTwoVariableMonthlyIncome] = useState<number>(0);
    const [totalSectionTwoVariableAnnualIncome, setSectionTwoVariableAnnualIncome] = useState<number>(0);

    const [totalSectionThreeMonthlyIncome, setSectionThreeMonthlyIncome] = useState<number>(0);
    const [totalSectionThreeAnnualIncome, setSectionThreeAnnualIncome] = useState<number>(0);

    const [totalSectionFourMonthlyIncome, setSectionFourMonthlyIncome] = useState<number>(0);
    const [totalSectionFourAnnualIncome, setSectionFourAnnualIncome] = useState<number>(0);

    const { control, register, reset, setValue, getValues, watch, handleSubmit, formState: { errors } } = useForm<PersonalIncomeFormI>({
        defaultValues: initData,
        // resolver: yupResolver(PersonalIncomeValidate)
    });

    useEffect(() => {
        // reset(initData);
        // initialiseForm();
        fetchMonthlyIncome();
    }, [])

    const initialiseForm = () => {

        addMoreSectionOneOtherIncome([
            { title: t('childSupportAlimony'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('socialSecurityIncome'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('disabilityIncome'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('pensions'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('investments'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('realEstateInvestments'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('businessIncome'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('otherIncome'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: false, monthly_amount_read_only: false, annual_amount_read_only: true },
        ]);
        addMoreSectionTwoFixedExpense([
            { title: t('payrollTaxes'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('otherIncomeDeductions'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('rentMortgage'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('loansHomeEquity'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('propertyTaxes'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('water'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('garbage'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('gasAndElectricBills'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('autoInsurance'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('autoRepairs'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('groceries'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('necessaryClothing'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('landlinePhone'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('homeRentersInsurance'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('healthcareInsurancePremium'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('dentalInsurancePremium'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('lifeInsurancePremium'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('studentLoanPaymentMonthly'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('childDependentSupportExpenses'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('alimonySpousalSupport'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('homeOwnersAssociationDues'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('otherFixed'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: false, monthly_amount_read_only: false, annual_amount_read_only: true },
        ]);
        addMoreSectionTwoVariableExpense([
            { title: t('creditCardPayments'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('autoLoanPayments'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('gas'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('cableOrTV'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('mobilePhone'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('homeImprovementRepairs'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('homeSupplies'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('dryCleaning'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('laundryOther'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('investmentRealEstateExpenses'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('childcare'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('childBabyExpensesOther'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('entertainment'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('diningOut'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('vacations'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('petCosts'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('gifts'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('internet'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('technology'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('otherVariable'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: false, monthly_amount_read_only: false, annual_amount_read_only: true },
        ]);
        addMoreSectionThreeInvestments([
            { title: t('iraDeposits'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: true, annual_amount_read_only: false },
            { title: t('employeeStockPlans'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('brokerageDeposits'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('otherInvestments'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: false, monthly_amount_read_only: false, annual_amount_read_only: true },
        ]);
        addMoreSectionFourBudgets([
            { title: t('totalIncome'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: true, annual_amount_read_only: true },
            { title: t('fixedExpenses'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: true, annual_amount_read_only: true },
            { title: t('netIncome'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: true, annual_amount_read_only: true },
            { title: t('investments'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: true, annual_amount_read_only: true },
            { title: t('netIncomeMinusInvestments'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: true, annual_amount_read_only: true },
            { title: t('variableExpenses'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: true, annual_amount_read_only: true },
        ]);
        addMoreSectionOnePrimaryIncome([
            { title: t('yourIncome'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
            { title: t('yourSpousesIncome'), monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: true, monthly_amount_read_only: false, annual_amount_read_only: true },
        ]);

        setTotalSectionOneMonthlyIncome(0);
        setTotalSectionOneAnnualIncome(0);

        setSectionTwoFixedMonthlyIncome(0);
        setSectionTwoFixedAnnualIncome(0);

        setSectionTwoVariableMonthlyIncome(0);
        setSectionTwoVariableAnnualIncome(0);

        setSectionThreeMonthlyIncome(0);
        setSectionThreeAnnualIncome(0);

        setSectionFourMonthlyIncome(0);
        setSectionFourAnnualIncome(0);

        setTimeout(() => {
            window.scrollTo(0, 0)
        }, 0);
    }

    const formatToUSD = (amount: number): string => {
        return amount.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 });
    };
    const calculateSectionOneTotalIncome = () => {
        let monthlyTotal = 0, annualTotal = 0;

        getValues().section_one_primary_income.forEach((field: any) => {
            monthlyTotal += +field.monthly_amount || 0;
        });
        getValues().section_one_other_income.forEach((field: any) => {
            monthlyTotal += +field.monthly_amount || 0;
        });

        getValues().section_one_primary_income.forEach((field: any) => {
            annualTotal += +field.annual_amount || 0;
        })
        getValues().section_one_other_income.forEach((field: any) => {
            annualTotal += +field.annual_amount || 0;
        })

        setTotalSectionOneMonthlyIncome(monthlyTotal);
        setValue('section_four_budgets.0.monthly_amount', +parseFloat('' + monthlyTotal).toFixed(2));
        setValue('section_four_budgets.2.monthly_amount', +parseFloat('' + (monthlyTotal - getValues('section_four_budgets.1.monthly_amount'))).toFixed(2));

        setTotalSectionOneAnnualIncome(annualTotal);
        setValue('section_four_budgets.0.annual_amount', +parseFloat('' + annualTotal).toFixed(2));
        setValue('section_four_budgets.2.annual_amount', +parseFloat('' + (annualTotal - getValues('section_four_budgets.1.annual_amount'))).toFixed(2));

        setValue('section_four_budgets.4.monthly_amount', +parseFloat('' + (monthlyTotal - getValues('section_four_budgets.1.monthly_amount') - getValues('section_four_budgets.3.monthly_amount'))).toFixed(2));
        setValue('section_four_budgets.4.annual_amount', +parseFloat('' + (annualTotal - getValues('section_four_budgets.1.annual_amount') - getValues('section_four_budgets.3.annual_amount'))).toFixed(2));

        calculateSectionFourIncome();
    }
    const calculateSectionTwoFixedIncome = () => {
        let monthlyTotal = 0, annualTotal = 0;

        getValues().section_two_fixed_expense.forEach((field: any) => {
            monthlyTotal += +field.monthly_amount || 0;
        });
        getValues().section_two_fixed_expense.forEach((field: any) => {
            annualTotal += +field.annual_amount || 0;
        })

        setSectionTwoFixedMonthlyIncome(monthlyTotal);
        setValue('section_four_budgets.1.monthly_amount', +parseFloat('' + monthlyTotal).toFixed(2));
        setValue('section_four_budgets.2.monthly_amount', +parseFloat('' + (getValues('section_four_budgets.0.monthly_amount') - monthlyTotal)).toFixed(2));

        setSectionTwoFixedAnnualIncome(annualTotal);
        setValue('section_four_budgets.1.annual_amount', +parseFloat('' + annualTotal).toFixed(2));
        setValue('section_four_budgets.2.annual_amount', +parseFloat('' + (getValues('section_four_budgets.0.annual_amount') - annualTotal)).toFixed(2));

        setValue('section_four_budgets.4.monthly_amount', +parseFloat('' + (getValues('section_four_budgets.0.monthly_amount') - monthlyTotal - getValues('section_four_budgets.3.monthly_amount'))).toFixed(2));
        setValue('section_four_budgets.4.annual_amount', +parseFloat('' + (getValues('section_four_budgets.0.annual_amount') - annualTotal - getValues('section_four_budgets.3.annual_amount'))).toFixed(2));

        calculateSectionFourIncome();
    };
    const calculateSectionTwoVariableIncome = () => {
        let monthlyTotal = 0, annualTotal = 0;
        getValues().section_two_variable_expense.forEach((field: any) => {
            monthlyTotal += +field.monthly_amount || 0;
        });
        getValues().section_two_variable_expense.forEach((field: any) => {
            annualTotal += +field.annual_amount || 0;
        })

        setSectionTwoVariableMonthlyIncome(monthlyTotal);
        setSectionTwoVariableAnnualIncome(annualTotal);

        setValue('section_four_budgets.5.monthly_amount', +parseFloat('' + monthlyTotal).toFixed(2));
        setValue('section_four_budgets.5.annual_amount', +parseFloat('' + annualTotal).toFixed(2));

        calculateSectionFourIncome()
    };
    const calculateSectionThreeIncome = () => {
        let monthlyTotal = 0, annualTotal = 0;
        getValues().section_three_investments.forEach((field: any) => {
            monthlyTotal += +field.monthly_amount || 0;
        });
        getValues().section_three_investments.forEach((field: any) => {
            annualTotal += +field.annual_amount || 0;
        });

        setSectionThreeMonthlyIncome(monthlyTotal);
        setValue('section_four_budgets.3.monthly_amount', +parseFloat('' + monthlyTotal).toFixed(2));
        setValue('section_four_budgets.4.monthly_amount', +parseFloat('' + (getValues('section_four_budgets.2.monthly_amount') - monthlyTotal)).toFixed(2));

        setSectionThreeAnnualIncome(annualTotal);
        setValue('section_four_budgets.3.annual_amount', +parseFloat('' + annualTotal).toFixed(2));
        setValue('section_four_budgets.4.annual_amount', +parseFloat('' + (getValues('section_four_budgets.2.annual_amount') - annualTotal)).toFixed(2));

        calculateSectionFourIncome()
    };
    const calculateSectionFourIncome = () => {
        let monthlyTotal = 0, annualTotal = 0;
        getValues().section_four_budgets.forEach((field) => {
            monthlyTotal += field.monthly_amount || 0;
        });
        getValues().section_four_budgets.forEach((field) => {
            annualTotal += field.annual_amount || 0;
        });

        setSectionFourMonthlyIncome(monthlyTotal);
        setSectionFourAnnualIncome(annualTotal);
    };

    const { fields: sectionOnePrimaryIncomeFields, append: addMoreSectionOnePrimaryIncome, remove: deleteSectionOnePrimaryIncome } = useFieldArray({
        control,
        name: 'section_one_primary_income',
    });
    const { fields: sectionOneOtherIncomeFields, append: addMoreSectionOneOtherIncome, remove: deleteSectionOneOtherIncome } = useFieldArray({
        control,
        name: 'section_one_other_income',
    });
    const { fields: sectionTwoFixedExpenseFields, append: addMoreSectionTwoFixedExpense, remove: deleteSectionTwoFixedExpense } = useFieldArray({
        control,
        name: 'section_two_fixed_expense',
    });
    const { fields: sectionTwoVariableExpenseFields, append: addMoreSectionTwoVariableExpense, remove: deleteSectionTwoVariableExpense } = useFieldArray({
        control,
        name: 'section_two_variable_expense',
    });
    const { fields: sectionThreeInvestmentsFields, append: addMoreSectionThreeInvestments, remove: deleteSectionThreeInvestments } = useFieldArray({
        control,
        name: 'section_three_investments',
    });
    const { fields: sectionFourBudgetsFields, append: addMoreSectionFourBudgets, remove: deleteSectionFourBudgets } = useFieldArray({
        control,
        name: 'section_four_budgets',
    });


    const _handleChangeSearchParam = (e: any, type: string) => {
        if (type === 'month') {
            setSearchParams({
                ...searchParams,
                'month': e
            })
        } else if (type === 'year') {
            setSearchParams({
                ...searchParams,
                'year': e
            })
        }
    }

    const fetchMonthlyIncome = () => {
        setIsLoading(true);
        const data = {
            // month: searchParams['month']['value'],
            year: searchParams['year']['value'],
            branch_id: +branchData['id']
        }
        getPersonalIncomeStatment(data, (message: string, resp: any) => {
            const data = resp.data.data;
            reset();

            if (data) {
                setIsEdit(true)
                data['section_one_primary_income'].map((item: any) => {
                    addMoreSectionOnePrimaryIncome({ ...item, title_read_only: true, monthly_amount_read_only: true, annual_amount_read_only: true })
                })
                data['section_one_other_income'].map((item: any) => {
                    addMoreSectionOneOtherIncome({ ...item, title_read_only: true, monthly_amount_read_only: true, annual_amount_read_only: true })
                })
                data['section_two_fixed_expense'].map((item: any) => {
                    addMoreSectionTwoFixedExpense({ ...item, title_read_only: true, monthly_amount_read_only: true, annual_amount_read_only: true })
                })
                data['section_two_variable_expense'].map((item: any) => {
                    addMoreSectionTwoVariableExpense({ ...item, title_read_only: true, monthly_amount_read_only: true, annual_amount_read_only: true })
                })
                data['section_three_investments'].map((item: any) => {
                    addMoreSectionThreeInvestments({ ...item, title_read_only: true, monthly_amount_read_only: true, annual_amount_read_only: true })
                })
                data['section_four_budgets'].map((item: any) => {
                    addMoreSectionFourBudgets({ ...item, title_read_only: true, monthly_amount_read_only: true, annual_amount_read_only: true })
                })

                calculateSectionOneTotalIncome();
                calculateSectionTwoFixedIncome();
                calculateSectionTwoVariableIncome();
                calculateSectionThreeIncome();
                calculateSectionFourIncome();

                setTimeout(() => {
                    window.scrollTo(0, 0)
                }, 0);
            } else {
                setIsEdit(false);
                reset(initData);
                initialiseForm();
            }

            setIsLoading(false);
        }, (message: string, resp: any) => {
            setIsLoading(false);
        })
    }

    const saveMonthlyIncome = (data: any) => {
        setIsLoading(true);
        const payload = {
            queryString: {
                year: searchParams['year']['value'],
                branch_id: +branchData['id']
            },
            data
        }

        createPersonalIncomeStatment(payload, (message: string, resp: any) => {
            captureContentAndGeneratePDF();
            // generatePdf();
            setIsLoading(false);
            toast.success(message);
            // reset(initData);
            // initialiseForm();
        }, (message: string, resp: any) => {
            setIsLoading(false);
            toast.error(message);
        })
    }

    const submitForm = () => {
        handleSubmit(saveMonthlyIncome)();
    };

    const generatePdf = async () => {
        const element = document.querySelector('.personal-balance-sheet.main-table') as HTMLElement;

        if (!element) {
            alert('Table not found!');
            return;
        }

        // Use html2pdf.js to generate the PDF
        const opt = {
            margin: 0.5,
            filename: 'personal_balance_sheet.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        };

        html2pdf()
            .from(element)
            .set(opt)
            .save();
    };


    const captureContentAndGeneratePDF = async () => {
        const pdf = new jsPDF('p', 'pt', 'a4');

        for (let i = 0; i < pagesRefs.current.length; i++) {
            const pageRef = pagesRefs.current[i];

            if (pageRef === null) {
                continue; // Skip if ref is null
            }

            // Capture the content of each page
            const canvas = await html2canvas(pageRef, { scale: 3 });

            // Add a new page if not the first page
            if (i > 0) {
                pdf.addPage();
            }

            // Add the captured content as an image to the PDF
            pdf.addImage(canvas.toDataURL('image/jpeg', 1.0), 'JPEG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());
        }

        // Save or download the PDF
        pdf.save(`Personal/Family Income Statement(${searchParams['year']['value']}).pdf`);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLFormElement>) => {
        if (event.key === 'Enter' || event.keyCode === 13) {
            event.preventDefault();
        }
    };

    return (
        <div className="main-container flex-grow-1">
            <div className="container-fluid">
                <div className="page-title pb-4 pt-3">
                    <div className="row align-items-center">
                        <div className="col-sm-6 align-items-center d-flex">
                            <h1 className="h3 font-weight-700 mb-0 d-inline-flex">{t('pageTitle')}</h1>
                        </div>
                    </div>
                </div>
                <div className="filter-box-top">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="filter-wrap">
                                <div className="filter-box">
                                    <Select
                                        onChange={(e: any) => _handleChangeSearchParam(e, 'year')}
                                        options={lastYears(5)}
                                        defaultValue={searchParams['year']}
                                        className={'zindex-10'}
                                    />
                                </div>

                                <div className="filter-btn">
                                    <button type="button" onClick={fetchMonthlyIncome}><img src={filterSolidIcon} alt="" />{t('generateForm')}</button>
                                </div>
                                <div className="filter-btn">
                                    <div className={`page-loader ${isLoading ? 'visible' : ''}`}>
                                        <div className="loader"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="executive-dashboard">
                        <Form onKeyDown={handleKeyDown}>
                            <div>
                                <table className="personal-balance-sheet main-table" ref={ref => pagesRefs.current[0] = ref}>
                                    <tr className="header">
                                        <th className='widthTitle' >{t('section1')}</th>
                                        <th className='text-center widthMonthAnnual' >{t('monthlyBudget')}</th>
                                        <th className='text-center widthMonthAnnual' >{t('annualAmount')}</th>
                                        <th className='text-center widthNotes' >{t('notes')}</th>
                                    </tr>
                                    <tr className='grey-background'>
                                        <td className='header-title'>{t('primaryIncome')}</td>
                                        <td className='header-title-extra-tds'></td>
                                        <td className='header-title-extra-tds'></td>
                                        <td className='header-title-extra-tds'></td>
                                    </tr>
                                    {sectionOnePrimaryIncomeFields.map((item: any, index: number) => (
                                        <tr key={item.id}>
                                            <td className='titleColumn' >
                                                {item.title}
                                            </td>
                                            <td className='whiteColumn' >
                                                <input
                                                    type='number'
                                                    {...register(`section_one_primary_income.${index}.monthly_amount`)}
                                                    placeholder="Amount"
                                                    readOnly={item.monthly_amount_read_only}
                                                    onChange={(e) => {
                                                        const annualAmount = +e.target.value * 12;
                                                        setValue(`section_one_primary_income.${index}.monthly_amount`, +e.target.value);
                                                        setValue(`section_one_primary_income.${index}.annual_amount`, +parseFloat('' + annualAmount).toFixed(2));
                                                        calculateSectionOneTotalIncome();
                                                    }}
                                                    className={item.monthly_amount_read_only ? 'input-disabled-look' : ''}
                                                />
                                            </td>
                                            <td className='blueColumn' >
                                                <input
                                                    type='number'
                                                    {...register(`section_one_primary_income.${index}.annual_amount`)}
                                                    placeholder="Amount"
                                                    readOnly={item.annual_amount_read_only}
                                                    className={item.annual_amount_read_only ? 'input-disabled-look' : ''}
                                                />
                                            </td>
                                            <td className='noteColumn' >
                                                <input
                                                    type='text'
                                                    {...register(`section_one_primary_income.${index}.notes`)}
                                                // placeholder="Note"

                                                />
                                            </td>
                                            {/* <button type="button" onClick={() => deleteAnnualIncome(index)}>Remove</button> */}
                                        </tr>
                                    ))}
                                    <tr className='grey-background'>
                                        <td className='header-title'>{t('otherIncomeSources')}</td>
                                        <td className='header-title-extra-tds'></td>
                                        <td className='header-title-extra-tds'></td>
                                        <td className='header-title-extra-tds'></td>
                                    </tr>
                                    {sectionOneOtherIncomeFields.map((item: any, index: number) => (
                                        <tr key={item.id}>
                                            <td className='titleColumn' >
                                                {item.title}
                                            </td>
                                            <td className='whiteColumn' >
                                                <input
                                                    type='number'
                                                    {...register(`section_one_other_income.${index}.monthly_amount`)}
                                                    placeholder="Amount"
                                                    readOnly={item.monthly_amount_read_only}
                                                    onChange={(e) => {
                                                        const annualAmount = +e.target.value * 12;
                                                        setValue(`section_one_other_income.${index}.monthly_amount`, +e.target.value);
                                                        setValue(`section_one_other_income.${index}.annual_amount`, +parseFloat('' + annualAmount).toFixed(2));
                                                        calculateSectionOneTotalIncome();
                                                    }}
                                                />
                                            </td>
                                            <td className='blueColumn' >
                                                <input
                                                    type='number'
                                                    {...register(`section_one_other_income.${index}.annual_amount`)}
                                                    placeholder="Amount"
                                                    readOnly={item.annual_amount_read_only}
                                                    className={item.annual_amount_read_only ? 'input-disabled-look' : ''}
                                                />
                                            </td>
                                            <td className='noteColumn' >
                                                <input
                                                    type='text'
                                                    {...register(`section_one_other_income.${index}.notes`)}
                                                // placeholder="Note"
                                                />
                                            </td>
                                            {/* <button type="button" onClick={() => deleteAnnualIncome(index)}>Remove</button> */}
                                        </tr>
                                    ))}
                                    {
                                        // !isEdit && (
                                        //     <tr>
                                        //         <td >
                                        //             <button type="button" className='buttonAddRow' onClick={() => addMoreSectionOneOtherIncome({ title: '', monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: false, monthly_amount_read_only: false, annual_amount_read_only: false })}>Add Row</button>
                                        //         </td>
                                        //     </tr>
                                        // )
                                    }

                                    <tr className="total-row">
                                        <td className='text-left'>{t('totalHouseholdIncome')}</td>
                                        <td >{formatToUSD(parseFloat('' + totalSectionOneMonthlyIncome))}</td>
                                        <td >{formatToUSD(parseFloat('' + totalSectionOneAnnualIncome))}</td>
                                        <td className='bg-white'></td>
                                    </tr>
                                    <tr><td style={{ height: '20px' }}></td></tr>
                                    <tr className="header">
                                        <td >{t('section2')}</td>
                                        <td >{t('monthlyBudget')}</td>
                                        <td >{t('annualAmount')}</td>
                                        <td >{t('notes')}</td>
                                    </tr>
                                    <tr className='grey-background'>
                                        <td className='header-title'>{t('expensesFixed')}</td>
                                        <td className='header-title-extra-tds'></td>
                                        <td className='header-title-extra-tds'></td>
                                        <td className='header-title-extra-tds'></td>
                                    </tr>
                                    {sectionTwoFixedExpenseFields.map((item: any, index: number) => (
                                        <tr key={item.id}>
                                            <td className='titleColumn' >
                                                {item.title}
                                            </td>
                                            <td className='whiteColumn' >
                                                <input
                                                    type='number'
                                                    {...register(`section_two_fixed_expense.${index}.monthly_amount`)}
                                                    placeholder="Amount"
                                                    readOnly={item.monthly_amount_read_only}
                                                    onChange={(e) => {
                                                        const annualAmount = +e.target.value * 12;
                                                        setValue(`section_two_fixed_expense.${index}.monthly_amount`, +e.target.value);
                                                        setValue(`section_two_fixed_expense.${index}.annual_amount`, +parseFloat('' + annualAmount).toFixed(2));
                                                        calculateSectionTwoFixedIncome();
                                                    }}
                                                />
                                            </td>
                                            <td className='blueColumn' >
                                                <input
                                                    type='number'
                                                    {...register(`section_two_fixed_expense.${index}.annual_amount`)}
                                                    placeholder="Amount"
                                                    readOnly={item.annual_amount_read_only}
                                                />
                                            </td>
                                            <td className='noteColumn' >
                                                <input
                                                    type='text'
                                                    {...register(`section_two_fixed_expense.${index}.notes`)}
                                                // placeholder="Note"
                                                />
                                            </td>
                                            {/* <button type="button" onClick={() => deleteAnnualIncome(index)}>Remove</button> */}
                                        </tr>
                                    ))}
                                    {
                                        // !isEdit && (
                                        //     <tr>
                                        //         <td >
                                        //             <button type="button" className='buttonAddRow' onClick={() => addMoreSectionTwoFixedExpense({ title: '', monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: false, monthly_amount_read_only: false, annual_amount_read_only: false })}>Add Row</button>
                                        //         </td>
                                        //     </tr>
                                        // )
                                    }

                                    <tr className="total-row-pink">
                                        <td className='text-left'>{t('totalFixedExpenses')}</td>
                                        <td >{formatToUSD(parseFloat('' + totalSectionTwoFixedMonthlyIncome))}</td>
                                        <td >{formatToUSD(parseFloat('' + totalSectionTwoFixedAnnualIncome))}</td>
                                        <td className='bg-white'></td>
                                    </tr>
                                    <tr><td style={{ height: '20px' }}></td></tr>
                                    <tr className='grey-background'>
                                        <td className='header-title'>{t('expensesVariable')}</td>
                                        <td className='header-title-extra-tds'></td>
                                        <td className='header-title-extra-tds'></td>
                                        <td className='header-title-extra-tds'></td>
                                    </tr>
                                    {sectionTwoVariableExpenseFields.map((item: any, index: number) => (
                                        <tr key={item.id}>
                                            <td className='titleColumn' >
                                                {item.title}
                                            </td>
                                            <td className='whiteColumn' >
                                                <input
                                                    type='number'
                                                    {...register(`section_two_variable_expense.${index}.monthly_amount`)}
                                                    placeholder="Amount"
                                                    readOnly={item.monthly_amount_read_only}
                                                    onChange={(e) => {
                                                        const annualAmount = +e.target.value * 12;
                                                        setValue(`section_two_variable_expense.${index}.monthly_amount`, +e.target.value);
                                                        setValue(`section_two_variable_expense.${index}.annual_amount`, +parseFloat('' + annualAmount).toFixed(2));
                                                        calculateSectionTwoVariableIncome();
                                                    }}
                                                />
                                            </td>
                                            <td className='blueColumn' >
                                                <input
                                                    type='number'
                                                    {...register(`section_two_variable_expense.${index}.annual_amount`)}
                                                    placeholder="Amount"
                                                    readOnly={item.annual_amount_read_only}
                                                />
                                            </td>
                                            <td className='noteColumn' >
                                                <input
                                                    type='text'
                                                    {...register(`section_two_variable_expense.${index}.notes`)}
                                                // placeholder="Note"
                                                />
                                            </td>
                                            {/* <button type="button" onClick={() => deleteAnnualIncome(index)}>Remove</button> */}
                                        </tr>
                                    ))}
                                    {
                                        // !isEdit && (
                                        //     <tr>
                                        //         <td >
                                        //             <button type="button" className='buttonAddRow' onClick={() => addMoreSectionTwoVariableExpense({ title: '', monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: false, monthly_amount_read_only: false, annual_amount_read_only: false })}>Add Row</button>
                                        //         </td>
                                        //     </tr>
                                        // )
                                    }

                                    <tr className="total-row">
                                        <td className="text-left total-row-pink" >{t('totalVariableExpenses')}</td>
                                        <td className="total-row-pink">{formatToUSD(parseFloat('' + totalSectionTwoVariableMonthlyIncome))}</td>
                                        <td className="total-row-pink">{formatToUSD(parseFloat('' + totalSectionTwoVariableAnnualIncome))}</td>
                                        <td className="bg-white"></td>
                                    </tr>
                                    <tr><td style={{ height: '20px' }}></td></tr>
                                    <tr className="header">
                                        <td >{t('section3')}</td>
                                        <td >{t('monthlyBudget')}</td>
                                        <td >{t('annualAmount')}</td>
                                        <td >{t('notes')}</td>
                                    </tr>
                                    <tr className='grey-background'>
                                        <td className='header-title font-weight-bold' colSpan={6}>{t('investmentSpending')}</td>
                                    </tr>
                                    {sectionThreeInvestmentsFields.map((item: any, index: number) => (
                                        <tr key={item.id}>
                                            <td className='titleColumn' >
                                                <input
                                                    type='text'
                                                    {...register(`section_three_investments.${index}.title`)}
                                                    placeholder="Title"
                                                    readOnly={item.title_read_only}
                                                    className={item.title_read_only ? 'input-disabled-look' : ''}
                                                />
                                            </td>
                                            <td className='whiteColumn' >
                                                <input
                                                    type='number'
                                                    {...register(`section_three_investments.${index}.monthly_amount`)}
                                                    placeholder="Amount"
                                                    readOnly={item.monthly_amount_read_only}
                                                    onChange={(e) => {
                                                        const annualAmount = +e.target.value * 12;
                                                        setValue(`section_three_investments.${index}.monthly_amount`, +e.target.value);
                                                        setValue(`section_three_investments.${index}.annual_amount`, +parseFloat('' + annualAmount).toFixed(2));
                                                        calculateSectionThreeIncome();
                                                    }}
                                                    className={item.monthly_amount_read_only ? 'input-disabled-look' : ''}
                                                />
                                            </td>
                                            <td className='blueColumn' >
                                                <input
                                                    type='number'
                                                    {...register(`section_three_investments.${index}.annual_amount`)}
                                                    placeholder="Amount"
                                                    readOnly={item.annual_amount_read_only}
                                                    onChange={(e) => {
                                                        const annualAmount = +e.target.value / 12;
                                                        setValue(`section_three_investments.${index}.annual_amount`, +e.target.value);
                                                        setValue(`section_three_investments.${index}.monthly_amount`, +parseFloat('' + annualAmount).toFixed(2));
                                                        calculateSectionThreeIncome();
                                                    }}
                                                    className={item.annual_amount_read_only ? 'input-disabled-look' : ''}
                                                />
                                            </td>
                                            <td className='noteColumn' >
                                                <input
                                                    type='text'
                                                    {...register(`section_three_investments.${index}.notes`)}
                                                // placeholder="Note"
                                                />
                                            </td>
                                            {/* <button type="button" onClick={() => deleteAnnualIncome(index)}>Remove</button> */}
                                        </tr>
                                    ))}
                                    {
                                        // !isEdit && (
                                        //     <tr>
                                        //         <td >
                                        //             <button type="button" className='buttonAddRow' onClick={() => addMoreSectionThreeInvestments({ title: '', monthly_amount: 0, annual_amount: 0, notes: '', title_read_only: false, monthly_amount_read_only: false, annual_amount_read_only: true })}>Add Row</button>
                                        //         </td>
                                        //     </tr>
                                        // )
                                    }

                                    <tr className="total-row">
                                        <td className="text-left total-row-pink" >{t('totalInvestmentCosts')}</td>
                                        <td className="total-row-pink">{formatToUSD(parseFloat('' + totalSectionThreeMonthlyIncome))}</td>
                                        <td className="total-row-pink">{formatToUSD(parseFloat('' + totalSectionThreeAnnualIncome))}</td>
                                        <td className="bg-white"></td>
                                    </tr>
                                    <tr><td style={{ height: '20px' }}></td></tr>
                                    <tr className="header">
                                        <td >{t('section4')}</td>
                                        <td >{t('monthlyBudget')}</td>
                                        <td >{t('annualAmount')}</td>
                                        <td >{t('notes')}</td>
                                    </tr>
                                    {sectionFourBudgetsFields.map((item: any, index: number) => (
                                        <tr className={`titleColumn ${item.title === t('variableExpenses') ? 'total-row-yellow' : ''} `} key={item.id}>
                                            <td >
                                                <input
                                                    type='text'
                                                    {...register(`section_four_budgets.${index}.title`)}
                                                    placeholder={t('variableExpenses')}
                                                    readOnly={item.title_read_only}
                                                    className={item.title_read_only ? 'input-disabled-look' : ''}
                                                />
                                            </td>
                                            <td className='titleColumn' >
                                                <input
                                                    type='number'
                                                    {...register(`section_four_budgets.${index}.monthly_amount`)}
                                                    placeholder={t('monthlyBudget')}
                                                    readOnly={item.monthly_amount_read_only}
                                                    className={item.monthly_amount_read_only ? 'input-disabled-look' : ''}
                                                />
                                            </td>
                                            <td className='titleColumn' >
                                                <input
                                                    type='number'
                                                    {...register(`section_four_budgets.${index}.annual_amount`)}
                                                    placeholder={t('annualAmount')}
                                                    readOnly={item.annual_amount_read_only}
                                                    className={item.annual_amount_read_only ? 'input-disabled-look' : ''}
                                                />
                                            </td>
                                            <td className='titleColumn' >
                                                <input
                                                    type='text'
                                                    {...register(`section_four_budgets.${index}.notes`)}
                                                // placeholder={t('notes')}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                    <tr className="total-row">
                                        <td >{t('disposableIncomeSavings')}</td>
                                        <td >{formatToUSD(parseFloat('' + totalSectionFourMonthlyIncome))}</td>
                                        <td >{formatToUSD(parseFloat('' + totalSectionFourAnnualIncome))}</td>
                                        <td className='bg-white'></td>
                                    </tr>
                                </table>
                            </div>
                            <button type="button" onClick={submitForm} className="btn btn-primary mt-4">
                                {showLoader && (<Spinner animation="border" size="sm" />) || t('saveAndGeneratePDF')}
                            </button>


                        </Form>
                    </div>

                </div>
            </div>
        </div>

    )
}

export default PersonalIncomeStatement;